import React, { useState } from 'react'
import { X, ClipboardCheck, Play, Instagram, Phone } from 'lucide-react'
import './TutorInfo.css'

const TutorInfo = () => {
  const [activeRequirements, setActiveRequirements] = useState(null)
  const [expandedStep, setExpandedStep] = useState(null)

  const getStepDetails = (stepName) => {
    const normalized = stepName.toLowerCase().trim();
    if (normalized.includes('entrevista nivelatoria')) {
      return 'Esta entrevista es una introducción al voluntariado donde se recibe una asesoría previa con información (redes, números, etc.). Se realiza de forma presencial en la sede de nuestro voluntariado en la UNAH campus Cortés.';
    }
    if (normalized.includes('clase demostrativa')) {
      return 'Es una clase que no debe durar más de 30 minutos, donde se defiende un tema estandarizado en una rúbrica en base a la plaza o rama donde deseas ser tutor.';
    }
    return null;
  };

  const requirementsData = {
    vtic: {
      title: 'Tutores Lucem Aspicio',
      color: '#1A2B5B',
      logo: 'https://res.cloudinary.com/dcm2dsjov/image/upload/v1757627650/Agregar_un_subt%C3%ADtulo_10_irdlej.png',
      requirements: [
        'Carta de recomendación de un Catedrático',
        'Forma 03',
        'Historial Académico',
        'Currículum Vitae (CV)'
      ],
      process: [
        'Entrevista Nivelatoria',
        'Clase demostrativa',
        'Acreditación oficial'
      ]
    },
    aurora: {
      title: 'Tutores Aurora',
      color: '#D10056',
      logo: 'https://res.cloudinary.com/dcm2dsjov/image/upload/v1781922678/ChatGPT_Image_14_jun_2026_20_46_17_1_zvgvzq.png',
      requirements: [
        'Carta de motivación personal',
        'Antecedentes penales',
        'Forma 03',
        'Currículum Vitae (CV)'
      ],
      process: [
        'Entrevista nivelatoria',
        'Curso Prepedagógico'
      ]
    },
    eucs: {
      title: 'Tutores EUCS',
      color: '#7E161C',
      logo: 'https://res.cloudinary.com/dcm2dsjov/image/upload/v1774911286/Logo-VTIC_44_uovqwp.png',
      requirements: [
        'Carta de recomendación de un Catedrático',
        'Forma 03',
        'Historial Académico',
        'Currículum Vitae (CV)'
      ],
      process: [
        'Entrevista Nivelatoria',
        'Clase demostrativa',
        'Acreditación oficial'
      ]
    },
    phuma: {
      title: 'Tutores Phuma',
      color: '#C25E00',
      logo: 'https://res.cloudinary.com/dcm2dsjov/image/upload/v1781922617/image_5_kwwbny.png',
      requirements: [
        'Forma 03',
        'Currículum Vitae (CV)',
        'Tener cursado al menos el 25% de la carrera universitaria'
      ],
      process: [
        'Entrevista nivelatoria',
        'Curso Prepedagógico'
      ]
    }
  }

  return (
    <div className="tutor-info-page">
      <div className="tutor-container">
        {/* Header Section */}
        <div className="tutor-header">
          <h1 className="tutor-title">Cómo Ser Tutor</h1>
          <div className="divider"></div>
          <p className="tutor-subtitle">
            Agentes de cambio, innovación y creatividad académica
          </p>
          <div className="tutor-header-contact">
            <span className="contact-text">Contáctanos para unirte:</span>
            <div className="header-contact-icons">
              <a 
                href="https://www.instagram.com/vtic.unahcortes?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="header-contact-icon instagram"
                title="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a 
                href="https://wa.me/50497773865" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="header-contact-icon whatsapp"
                title="WhatsApp"
              >
                <Phone size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Sección de Áreas de Voluntariado / Tipos de Tutores */}
        <div className="tutor-types-section">
          <h2 className="section-main-title">Voluntariado de tutores e investigación científica: nuestras áreas</h2>
          <p className="section-main-subtitle">Conoce los diferentes grupos y perfiles de tutores que conforman nuestra comunidad</p>
          
          <div className="tutor-types-list">
            {/* Lucem Aspicio */}
            <div className="tutor-type-card vtic-theme">
              <div className="tutor-type-logo-container">
                <img src="https://res.cloudinary.com/dcm2dsjov/image/upload/v1757627650/Agregar_un_subt%C3%ADtulo_10_irdlej.png" alt="Lucem Aspicio Logo" className="tutor-type-svg" style={{ objectFit: 'contain', borderRadius: '50%' }} />
              </div>
              <div className="tutor-type-content-box">
                <h3>Tutores Lucem Aspicio</h3>
                <p>
                  Esta sección abarca el grupo de tutores calificados para dar tutorías a nivel universitario de clases que pueden generar complicaciones o dificultades en los jóvenes. Dentro de esta sección tenemos un área de desarrollo científico y pedagógico.
                </p>
                <div className="tutor-type-bullets">
                  <span>♦ Investigación</span>
                  <span>♦ Tutorías por pares</span>
                  <span>♦ Grupos de estudio</span>
                </div>
                <button className="view-reqs-btn vtic-hover" onClick={() => setActiveRequirements('vtic')}>
                  Ver Requisitos y Proceso
                </button>
              </div>
            </div>

            {/* Aurora */}
            <div className="tutor-type-card aurora-theme">
              <div className="tutor-type-logo-container">
                <img src="https://res.cloudinary.com/dcm2dsjov/image/upload/v1781922678/ChatGPT_Image_14_jun_2026_20_46_17_1_zvgvzq.png" alt="Aurora Logo" className="tutor-type-svg" style={{ objectFit: 'contain', borderRadius: '50%' }} />
              </div>
              <div className="tutor-type-content-box">
                <h3>Tutores Aurora</h3>
                <p>
                  Esta unidad de tutores proporciona apoyo social y tutorías a escuelas públicas mediante la Fundación Kappa. Se conforma por tutores, equipo pedagógico y de salud.
                </p>
                <div className="tutor-type-bullets">
                  <span>♦ Social</span>
                  <span>♦ Jóvenes y Niños</span>
                  <span>♦ Salud y Pedagogía</span>
                </div>
                <button className="view-reqs-btn aurora-hover" onClick={() => setActiveRequirements('aurora')}>
                  Ver Requisitos y Proceso
                </button>
              </div>
            </div>

            {/* EUCS */}
            <div className="tutor-type-card eucs-theme">
              <div className="tutor-type-logo-container">
                <img src="https://res.cloudinary.com/dcm2dsjov/image/upload/v1774911286/Logo-VTIC_44_uovqwp.png" alt="EUCS Logo" className="tutor-type-svg" style={{ objectFit: 'contain', borderRadius: '50%' }} />
              </div>
              <div className="tutor-type-content-box">
                <h3>Tutores EUCS</h3>
                <p>
                  Esta unidad conformada por jóvenes del área de salud, como puede ser odontología, medicina y enfermería, es un grupo de tutores que apoya de diversas formas a jóvenes en clases desafiantes del área de la salud. También promueven la investigación y el desarrollo.
                </p>
                <div className="tutor-type-bullets">
                  <span>♦ Salud</span>
                  <span>♦ Desarrollo</span>
                  <span>♦ Tutorías</span>
                </div>
                <button className="view-reqs-btn eucs-hover" onClick={() => setActiveRequirements('eucs')}>
                  Ver Requisitos y Proceso
                </button>
              </div>
            </div>

            {/* Phuma */}
            <div className="tutor-type-card phuma-theme">
              <div className="tutor-type-logo-container">
                <img src="https://res.cloudinary.com/dcm2dsjov/image/upload/v1781922617/image_5_kwwbny.png" alt="Phuma Logo" className="tutor-type-svg" style={{ objectFit: 'contain', borderRadius: '50%' }} />
              </div>
              <div className="tutor-type-content-box">
                <h3>Tutores Phuma</h3>
                <p>
                  Son los tutores encargados de proporcionar tutorías a los jóvenes previo a realizar la prueba PHUMA, prueba para acceder a nuestra universidad.
                </p>
                <div className="tutor-type-bullets">
                  <span>♦ Capacitación</span>
                  <span>♦ Preparación</span>
                  <span>♦ PHUMA</span>
                </div>
                <button className="view-reqs-btn phuma-hover" onClick={() => setActiveRequirements('phuma')}>
                  Ver Requisitos y Proceso
                </button>
              </div>
            </div>
          </div>
        </div>      </div>

      {activeRequirements && (() => {
        const data = requirementsData[activeRequirements]
        return (
          <div className="reqs-modal-overlay" onClick={() => { setActiveRequirements(null); setExpandedStep(null); }}>
            <div className="reqs-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="reqs-modal-close-btn" onClick={() => { setActiveRequirements(null); setExpandedStep(null); }}>
                <X size={20} />
              </button>
              <div className="reqs-modal-header" style={{ backgroundColor: data.color }}>
                <img src={data.logo} alt={data.title} className="reqs-modal-logo" />
                <h2>{data.title}</h2>
              </div>
              <div className="reqs-modal-body">
                <div className="reqs-modal-section">
                  <h3 className="reqs-section-title" style={{ color: data.color }}>
                    <ClipboardCheck size={20} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                    Requisitos
                  </h3>
                  <ul className="reqs-list">
                    {data.requirements.map((req, idx) => (
                      <li key={idx}>{req}</li>
                    ))}
                  </ul>
                </div>
                <div className="reqs-modal-section">
                  <h3 className="reqs-section-title" style={{ color: data.color }}>
                    <Play size={18} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                    Proceso de Selección
                  </h3>
                  <ol className="process-list">
                    {data.process.map((step, idx) => {
                      const detail = getStepDetails(step);
                      const isExpanded = expandedStep === idx;
                      return (
                        <li key={idx} className={detail ? 'has-details' : ''}>
                          <div 
                            className="process-item-main"
                            onClick={() => detail && setExpandedStep(isExpanded ? null : idx)}
                          >
                            <span className="process-number">{idx + 1}</span>
                            <span className="process-text">
                              {step}
                              {detail && (
                                <span className={`process-expand-icon ${isExpanded ? 'active' : ''}`}>
                                  {isExpanded ? '−' : '+'}
                                </span>
                              )}
                            </span>
                          </div>
                          {detail && isExpanded && (
                            <div className="process-item-detail">
                              {detail}
                            </div>
                          )}
                        </li>
                      );
                    })}
                  </ol>
                </div>
              </div>
            </div>
          </div>
        )
      })()}
    </div>
  )
}

export default TutorInfo